// extracted by mini-css-extract-plugin
module.exports = {"loading":"bo","fullscreenWrapper":"bp","centeredSpinner":"bq","rotation":"br","withoutLayer":"bs"};